import React, {useState,useEffect, useRef, useCallback} from 'react'
import './ModalPodControl.css'

function formatSeconds(seconds) {
  const min = String(Math.floor(seconds / 60)).padStart(2, '0');
  const sec = String(seconds % 60).padStart(2, '0');
  return `${min}:${sec}`;
}

const ModalPodControl = ({closeModal, onSubmit, podData}) => {
    const [remainingTime, setRemainingTime] = useState(0);
    const [currentStatus, setCurrentStatus] = useState('Trying to Connect...');
    const [clientId, setClientId] = useState('');
    const [clientName, setClientName] = useState('');
    const [protocolId, setProtocolId] = useState('');
    const [protocolName, setProtocolName] = useState('');
    const [sequenceInfo, setSequenceInfo] = useState('');

    const emptyResponseCounter = useRef(0);
    const statusLabels = {
        'start_program': 'Application Started',
        'complete': 'Protocol Complete',
        'log_out': 'Log Out',
        'exit_program': 'Application Exited',
        'log_in': 'Log In',
        'stop': 'Stopped Protocol',
        'logged_out': 'Logged Out',
        'logged_in': 'Logged In',
        'idle': 'Idle',
        'running': 'Running',
        'paused': 'Paused',
        'music': 'Music Playing',
        'fading_out': 'Music Fading Out'
    }

    const getKinesisData = useCallback(() => {
        return fetch(
                process.env.REACT_APP_API_URL_BASE + '/pod_status/valhalla-pod-status-' + podData.id,
                {
                    method: 'GET',
                    headers: {
                        'machine': '2',
                        'vh-key': '7df7f81e-aaff-444c-a01c-8caeaeab3e61',
                    },
                }
            )
            .then(res => res.json())
            .catch(error => {
                // console.error("Error fetching Kinesis data: ", error);
                return {};  // Fallback to empty object
            });
    }, [podData.id])

    // Kinesis Listener
    useEffect(() => {
        const interval = setInterval(async () => {
            const data = await getKinesisData();
            // console.log("Kinesis Data: ", data);

            const isEmpty = !data || Object.keys(data).length === 0;

            if (!isEmpty) {
                emptyResponseCounter.current = 0; // Reset counter on valid data
                setRemainingTime(data.total_time_remaining_sec);
                setCurrentStatus(data.event);
                // console.log("Current Status: ", data);
                if (data.client_id != null) {
                        setClientId(data.client_id);
                        setClientName(data.client_first_name + ' ' + data.client_last_name);
                    } else {
                        setClientId('');
                        setClientName('');
                    }
                if (data.protocol_id != null && data.protocol_id !== '') {
                    setProtocolId(data.protocol_id);
                } else {
                    setProtocolId('');
                }
                if (data.protocol_name != null && data.protocol_name !== '') {
                    setProtocolName(data.protocol_name);
                } else {
                    setProtocolName('');
                }
                if (data.music != null && data.music !== '') {
                }
                if (data.protocol_sequence != null && data.protocol_sequence !== 0) {
                    setSequenceInfo(data.protocol_sequence);
                }
                else {
                    setSequenceInfo('');
                }
                // console.log("sequenceInfo: ", data.protocol_sequence);
                //setSequenceInfo(data.protocol_sequence);

            } else {
                // Increment the empty response counter
                emptyResponseCounter.current += 1;

                // If 10 consecutive empty responses (30 seconds), set status
                if (emptyResponseCounter.current >= 10) {
                    setCurrentStatus('Trying to Connect...');
            }
        }
        }, 3000);

        return () => clearInterval(interval);
    }, [getKinesisData]);

    // Countdown Timer
    useEffect(() => {
    const timer = setInterval(() => {
        setRemainingTime((prev) => {
        if (currentStatus === 'running' && prev > 0) {
            return prev - 1;
        }
        return prev;
        });
    }, 1000);
    return () => clearInterval(timer);
    }, [currentStatus]);

    return (

    <div className='modal-container' onClick={(e) => {
        if (e.target.className === "modal-container")
        closeModal()
    }}>
      <div className='modal-pod-control-edit'>
        {/* <span className='close' onClick={closeModal}><button>Close</button></span> */}
        <div style={labelStyle}><h1>{formatSeconds(remainingTime)}</h1></div>
      <div style={labelStyle}><h3>{statusLabels[currentStatus] || currentStatus}</h3></div>

      {/* <h4>{podInfo.description} Status</h4> */}
      <table className='table-sessions'>
        <thead>
            <tr>
                <th>Customer</th>
                <th>Facility</th>
            </tr>
        </thead>
        <tbody>
            <tr>
                                <td>{podData.customer_name}</td>
                                <td>{podData.facility_name}</td>
            </tr>
        </tbody>
      </table>
      <table className='table-sessions'>
        <thead>
            <tr>
                <th>Pod ID</th>
                <th>Pod Type</th>
                <th>Pod Description</th>
            </tr>
        </thead>
        <tbody>
            <tr>
                                <td>{podData.id}</td>
                                <td>{podData.machine_type_description}</td>
                                <td>{podData.description}</td>
            </tr>
        </tbody>
      </table>

    <br></br>

      <table className='table-sessions'>
        <thead>
            <tr>
                <th>Client ID</th>
                <th>Client Name</th>
                {/* <th>Session</th>
                <th>Music</th> */}
            </tr>
        </thead>
        <tbody>
            <tr>
                <td>{clientId}</td>
                <td>{clientName}</td>
                {/* <td>{sessionId}</td>
                <td>{musicPlaying}</td> */}
            </tr>
        </tbody>
        </table>
        <br></br>
        <table className='table-sessions'>
        <thead>
            <tr>
                <th>Protocol ID</th>
                <th>Protocol Name</th>
                <th>Sequence</th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <td>{protocolId}</td>
                <td>{protocolName}</td>
                <td>{sequenceInfo}</td>
            </tr>
        </tbody>
        </table>
    </div>
    </div>
  );
}

const labelStyle = {
  fontSize: '20px',
  marginBottom: '10px'
};

export default ModalPodControl


